import React from "react";
import "./index.css";

function SimpleConditionValueRender({ label, value }) {
  return (
    <div style={{display: "flex", flexDirection: "row"}}>
      <div className="disabled-input-label">{label}</div>
      {(Array.isArray(value)) ?
        <div className={"condition-attribute-multiple-values"}>{renderMultipleValues(value)}</div> :
        <div className={"condition-attribute-value"}>{value}</div>
      }
    </div>
  );
}

function renderMultipleValues(values) {
  return values.map(value => <div className={"condition-attribute-value"}>{value}</div>)
}

export default SimpleConditionValueRender;
